var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',[_vm._v("Daniel Burke")]),_c('span',{staticClass:"pages"},[_c('span',{attrs:{"id":"selected_page"}},[_vm._v("who?")])])])}]

export { render, staticRenderFns }